exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table thead th[data-v-13fd7a57]{background:#eee}.table tbody tr:last-child td[data-v-13fd7a57],.table tbody tr:last-child th[data-v-13fd7a57],.table thead th[data-v-13fd7a57]{border:1px solid #ddd}", ""]);

// exports
